export default __webpack_public_path__ + "static/jaws-44b44c0d6e11168d94e8e6d90628a021.png";